<template>
  <div class="businessList">
    <h2>{{ title }}</h2>
    <el-table :data="businessList" :stripe="false" @selection-change="HandleSelectionChange"
      @sort-change="HandleSortChange" :show-header="false" style="box-shadow: none">
      <!-- 正常内容 -->
      <template>
        <!-- 用户昵称 -->
        <el-table-column width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.user.display_name }}
          </template>
        </el-table-column>
        
        <!-- 公司 -->
        <el-table-column width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.tenant ? scope.row.tenant.name : '-' }}
          </template>
        </el-table-column>


        <!-- 用户手机号 -->
        <el-table-column width="120">
          <template slot-scope="scope">
            <template v-if="scope.row.user && scope.row.user.mobile">
              {{ scope.row.user.mobile }}
            </template>
            <template v-else-if="!$store.state.session.host_token && request_mode=='visitor'">
              <span class="getMobile" @click="getMobile(scope.row)"> <i class="el-icon-phone-outline"></i> {{ l("获取号码") }} </span>
            </template>
          </template>
        </el-table-column>

        <!-- 信用等级 -->
        <el-table-column width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.tenant&&scope.row.tenant.credit_rating <= 2" effect="dark" placement="top">
              <div slot="content" style="width:200px">
                <div v-if="scope.row.tenant.credit_rating == 0">
                  <span class="color-danger">{{$store.state.basicInfo.credit_ratingList[0].tip_title}}: </span>{{ $store.state.basicInfo.credit_ratingList[0].tip_content_business }}
                </div>
                <div v-else-if="scope.row.tenant.credit_rating == 1">
                  <span class="color-warning">{{$store.state.basicInfo.credit_ratingList[1].tip_title}}: </span>{{ $store.state.basicInfo.credit_ratingList[1].tip_content_business }}
                </div>
                <div v-else-if="scope.row.tenant.credit_rating == 2">
                  <span class="color-success">{{$store.state.basicInfo.credit_ratingList[2].tip_title}}: </span>{{ $store.state.basicInfo.credit_ratingList[2].tip_content_business }}
                </div>
              </div>
              <div class="credit_level_info" :class="{
                'danger': scope.row.tenant.credit_rating == 0,
                'warning': scope.row.tenant.credit_rating == 1,
                'success': scope.row.tenant.credit_rating == 2,
              }">
                <i class="el-icon-warning"></i>
                {{
                  $utils.listFilter(
                    $store.state.basicInfo.credit_ratingList,
                    scope.row.tenant.credit_rating
                  )
                }}
              </div>
            </el-tooltip>

          </template>
        </el-table-column>





      </template>

      <!-- 详情 -->
      <el-table-column>
        <template slot-scope="scope">
          <div style="text-align: left !important">
            {{ l("报价") }}
            ：
            <span>
              <template v-if="scope.row.module == 'purchase'">
                {{ scope.row.price }}{{ l("元") }}{{ scope.row.unit?`/${scope.row.unit}`:undefined }}
                <!-- /{{scope.row.info.specification_amount[0].unit}} -->
                {{ scope.row.deliver_status }}
              </template>
              <template v-else-if="
                scope.row.module == 'quotation' || scope.row.module == 'raise'
              ">
                {{ scope.row.amount
                }}{{ scope.row.info.specification_amount[0].unit }}
              </template>
            </span>
            <span>
              {{ scope.row.extra_params }}
            </span>
          </div>
          <div v-if="scope.row.img_array" style="text-align:left">
            <el-image
              style="width:50px;height:50px;margin-right:5px;"
              v-for="item of scope.row.img_array"
              :key="item"
              :src="item"
              fit="contain"
              :preview-src-list="scope.row.img_array"
            ></el-image>
          </div>
        </template>
      </el-table-column>

      <!-- 日期 -->
      <el-table-column width="150">
        <template slot-scope="scope">
          <span style="color: #999;">
            {{scope.row.created_time.slice(0, 16)}}
          </span>
        </template>
      </el-table-column>
      <!-- 询价/报价来源者的专属业务员 -->
      <el-table-column width="70">
        <template slot-scope="scope" v-if="scope.row.user">
          <template v-if="manager_caigouList.length > 0">
            {{ $utils.listFilter(manager_caigouList, scope.row.user.manager_caigou_id, "display_name") }}
          </template>
          <template v-else-if="manager_shichangList.length > 0">
            {{ $utils.listFilter(manager_shichangList, scope.row.user.manager_shichang_id, "display_name") }}
          </template>
          <template v-else-if="manager_jijiagongList.length > 0">
            {{ $utils.listFilter(manager_jijiagongList, scope.row.user.manager_jijiagong_id, "display_name") }}
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="TotalCount" style="margin-top: 30px; justify-content: center" background
      @size-change="HandleSizeChange" @current-change="HandleCurrentChange" :current-page="CurrentPage"
      :page-sizes="PageSizeList" :page-size="PageSize" layout="total, prev, pager, next, jumper"
      :total="TotalCount"></el-pagination>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
export default {
  name: "BusinessList",
  mixins: [tableMixin],
  props: {
    code: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    manager_caigouList: {//父元素传入的采购部业务员list
      type: Array,
      default: () => []
    },
    manager_shichangList: {//父元素传入的市场部业务员list
      type: Array,
      default: () => []
    },
    manager_jijiagongList: {//父元素传入的机加工部业务员list
      type: Array,
      default: () => []
    },
    request_mode: {//请求模式
      type: String,
      default: "visitor",//visitor admin
    },
  },
  data() {
    return {
      Sorting: "-updated_time",
      businessList: [],
    };
  },
  computed: {
    from_simulator_salesman(){
      return this.$store.state.session.host_token_admin==2?true:null
    }
  },
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;
      this.axios
        .get(`/api/${this.request_mode=="admin"?'admin_purchase':'visitor_purchase'}/${this.code}/business_list/`, {
          params: {
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
            from_simulator_salesman: this.from_simulator_salesman,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.businessList = data.results.map(row=>{
            try {
              row.img_array = JSON.parse(row.img_array)
            } catch (error) {
              // console.log(error)
            }
            return row
          });
        });
    },
    getMobile(item){
      this.axios
        .post(`/api/visitor_purchase/unlock_purchase_business_action/`, {
          business_code : item.code,
          target_user_id: item.create_user_id,
        })
        .then(data => {
          if(data==1 || data==2){
            this.$alert(this.l("请联系专属业务员开通获取权限"), {
              confirmButtonText: this.l("前往联系"),
              center: true,
              callback: (res) => {
                if(res=="confirm"){
                  this.$router.push({ path: "/backend/dashboard" });
                }
              },
            });
          }else{
            item.user = data.user;
						item.tenant = data.tenant;
          }
        });
    }
  },
};
</script>


<style scoped lang="scss">
.businessList {
  font-size: 12px;
  padding: 0 10px;

  .businessItem {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 15px;

    .date {
      flex-shrink: 0;
      width: 120px;
      color: #999;
      text-align: right;
    }
  }
}

.credit_level_info {
  border-width: 1px;
  border-style: solid;
  line-height: 18px;
  font-size: 12px;
  padding: 0 4px;
  border-radius: 2px;
  margin-left: 6px;
  cursor: pointer;

  &.danger {
    color: $dangerColor;
    border-color: $dangerColor;
    background: $dangerPlainColor;
  }

  &.warning {
    color: $warningColor;
    border-color: $warningColor;
    background: $warningPlainColor;
  }

  &.success {
    color: $successColor;
    border-color: $successColor;
    background: $successPlainColor;
  }
}

.getMobile{
  color: $linkColor;
  cursor: pointer;
}
</style>
